import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow",
  "use": "svg_arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg_arrow\"><path d=\"m11.896 23.667-1.06-1.05 9.96-9.875H.333v-1.484h20.463l-9.96-9.875 1.06-1.05L23.666 12l-11.77 11.667Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol